export default "__VITE_PUBLIC_ASSET__df07ba99__"